import React, { useEffect } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import ConnectedRoute from '@AppRoutes/ConnectedRoute';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import Footer from '@Components/Footer';
import HeaderComponentContainer from '@Containers/Header/HeaderComponentContainer';
import { paths } from '@AppRoutes/constants';

import Account from './Account/AccountContainer';
import Profile from './Profile/ProfileContainer';
import Preferences from './Preferences/PreferencesContainer';
import ProfileSettingsHeader from './Components/ProfileSettingsHeader';

import './ProfileSettings.scss';

const spinnerId = 'profile-settings';

export default function ProfileSettings({ openSupplierPreferences, isLoading, init }) {
  useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  return (
    // FR-1.1/FR-3.3: ProfileSettings hand-rolls its own `.react-page` scroll root (it does not use
    // the shared `<Page>`), so it renders the main header inside that scroller itself and adds the
    // shared `react-page--header-inside` marker so Page.scss resets the header-era min/max-height.
    // `Main.jsx` suppresses its sibling header for `/profile-settings/*` so exactly one `#header`
    // renders. The header + "Profile" title scroll away; only the tab group stays sticky.
    //
    // A11y: this wrapper MUST stay a `<div>`, never a `<section>`/`<article>`/`<aside>`/`<nav>`/
    // `<main>`. Per HTML-AAM the Leyden `<Header>` (a bare `<header>` with no explicit `role`) only
    // maps to the `banner` landmark when it is NOT a descendant of one of those sectioning-content
    // elements — nesting it under a `<section>` here would silently strip that landmark (same fix
    // as Page.jsx).
    <div className="react-page-static profile-setting-page react-page react-page--header-inside">
      <HeaderComponentContainer type="main" />
      <section className="react-page-static__wrapper react-page--children-wrapper">
        <div className="profile-setting" id="main-content">
          <ProfileSettingsHeader />
          {isLoading && <SimpleSpinner id={spinnerId} />}
          {!isLoading && (
            <div className="profile-setting__content">
              <div className="profile-setting__content_tab">
                <Switch>
                  <ConnectedRoute path={paths.PROFILE_ACCOUNT} render={() => <Account />} />
                  <ConnectedRoute path={paths.PROFILE_PROFILE} render={() => <Profile />} />
                  <ConnectedRoute
                    path={paths.PROFILE_PREFERENCES}
                    render={() => <Preferences openSupplierPreferences={openSupplierPreferences} />}
                  />
                  <Redirect from="/profile-settings" to="/profile-settings/account" />
                </Switch>
              </div>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}

ProfileSettings.propTypes = {
  openSupplierPreferences: PropTypes.bool,
  isLoading: PropTypes.bool,
  init: PropTypes.func.isRequired,
};
